const API_URL = process.env.REACT_APP_API_URL;


export const fetchUserGroupsMapping = async (
  accessToken: string, 
  groupId?: number, 
  tenantID?: number
) => {
  try {
    
    
    // Construct the base URL
    let url = `${API_URL}${process.env.REACT_APP_USER_GROUPS_GET_MAPPING}`;

    // Add query parameters dynamically
    const params = new URLSearchParams();
    if (groupId) params.append("groupId", groupId.toString());
    if (tenantID) params.append("tenantID", tenantID.toString());

    // Append query parameters if there are any
    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch users.");
    }

    return response.json();
  } catch (error) {
    throw error;
  }
};


/**
 * Update user group mapping.
 * @param {string} accessToken - The user's access token.
 * @param {string} groupId - The group ID.
 * @param {Array<string>} selectedUserDetails - An array of user IDs.
 * @param {number} tenantID - The tenant ID.
 * @returns {Promise<void>} - Resolves if successful.
 */
export const updateUserGroupMapping = async (
  accessToken: string,
  groupId: number,
  selectedUserDetails: Array<string>,
  tenantID: number
) => { 
  try {
    // Prepare query parameters
    const params = new URLSearchParams();
    params.append("groupId", groupId.toString()); // Append groupId
    params.append("tenantID", tenantID.toString()); // Append tenantID

    // Append all selected user IDs
    selectedUserDetails.forEach((id) => params.append("userId", id.toString()));

    // Construct API URL with query parameters
    const apiUrl = `${API_URL}${process.env.REACT_APP_USER_GROUPS_UPDATE_MAPPING}?${params.toString()}`;

    // Make the API call
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to update user group mapping.");
    }
  } catch (error) {
    throw error;
  }
};
